export default __webpack_public_path__ + "static/media/logo-fathers-day-217px.bcb5710c.png";